import { render, staticRenderFns } from "./BookMultiPackage.vue?vue&type=template&id=52aa83cd&scoped=true"
import script from "./BookMultiPackage.vue?vue&type=script&lang=js"
export * from "./BookMultiPackage.vue?vue&type=script&lang=js"
import style0 from "./BookMultiPackage.vue?vue&type=style&index=0&id=52aa83cd&prod&lang=scss&scoped=true"
import style1 from "./BookMultiPackage.vue?vue&type=style&index=1&id=52aa83cd&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "52aa83cd",
  null
  
)

export default component.exports